import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {withStyles} from "@material-ui/core";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import SelectFilter from "./SelectFilter";
import Search from "./Search";
import t from "../../languages/pl";
import ActionCreator from './../../store/actions/index';

const useStyles = () => ({

    filterParametersRow: {
        display: "flex"

    }
});

const FilterParameters = props => {
    const {
        classes, group, groupOptions, brand, brandOptions, model, modelOptions, isGprs, gprsOptions, gprs,
        fuelType, fuelTypeOptions, gearbox, gearboxOptions, disableGearbox, registrationNoSearch, pharse
    } = props;

    return (
        <div className={classes.filterParametersRow}>
            {registrationNoSearch &&
                <Search
                    searchValue={pharse}
                    onSearchFieldChange={(value) => props.setSearchField(value)}
                    disableSelect
                />
            }
            <SelectFilter
                label={t.pickGroup}
                options={groupOptions}
                value={group}
                onChange={(e) => props.changeGroupFilter(e)}
            />
            <SelectFilter
                label={t.brand}
                options={brandOptions}
                value={brand}
                onChange={(e) => props.changeBrandFilter(e)}
            />
            <SelectFilter
                label={t.model}
                options={modelOptions}
                value={model}
                onChange={(e) => props.changeModelFilter(e)}
            />
            <SelectFilter
                label={t.fuel}
                options={fuelTypeOptions}
                value={fuelType}
                onChange={(e) => props.changeFuelType(e)}
            />
            {
                !disableGearbox
                &&
                <SelectFilter
                    label={t.gearBox}
                    options={gearboxOptions}
                    value={gearbox}
                    onChange={(e) => props.changeGearBoxFilter(e)}
                />
            }
            {
                isGprs &&
                <SelectFilter
                    label={t.gprs}
                    options={gprsOptions}
                    value={gprs}
                    onChange={(e) => props.changeGprsFilter(e)}
                />
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    pharse: state.filterReducer.searchField,
    group: state.filterReducer.group,
    brand: state.filterReducer.brand,
    model: state.filterReducer.model,
    gprs: state.filterReducer.gprs,
    fuelType: state.filterReducer.fuelType,
    gearbox: state.filterReducer.gearbox,
    gprsOptions: state.filterReducer.gprsOptions,
    groupOptions: state.filterReducer.groupOptions,
    brandOptions: state.filterReducer.brandOptions,
    modelOptions: state.filterReducer.modelOptions,
    fuelTypeOptions: state.filterReducer.fuelTypeOptions,
    gearboxOptions: state.filterReducer.gearboxOptions,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


FilterParameters.propTypes = {
    classes: PropTypes.object,
    disableGearbox: PropTypes.bool,
    //redux
    gprsOptions: PropTypes.array,
    group: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    groupOptions: PropTypes.array,
    brand: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    brandOptions: PropTypes.array,
    model: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    modelOptions: PropTypes.array,
    fuelType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fuelTypeOptions: PropTypes.array,
    gearbox: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    gearboxOptions: PropTypes.array,
    changeGroupFilter: PropTypes.func,
    changeBrandFilter: PropTypes.func,
    changeModelFilter: PropTypes.func,
    changeFuelType: PropTypes.func,
    changeGearBoxFilter: PropTypes.func,
    gprs: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    changeGprsFilter: PropTypes.func,
    registrationNoSearch: PropTypes.bool,
    setSearchField: PropTypes.func,
    pharse: PropTypes.string,
    isGprs: PropTypes.bool,
};

export default compose(withStyles(useStyles), connect(
    mapStateToProps,
    mapDispatchToProps
))(FilterParameters);
